import apiRoutes from "@/routes/apiRoutes";
import { GoogleLoginDTO, LoginDTO, SignUpDTO } from "@/types";

export const signUpUser = async (dto: SignUpDTO) => {
  try {
    const resp = await fetch(apiRoutes.auth.register, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });

    const result = await resp.json();

    if (!resp.ok || !result.succeeded) {
      const errorMessage = result.errors?.[0] || "Registration failed";
      return { success: false, error: errorMessage };
    }

    const data = result.data;

    const loggedInUser = {
      id: data.id,
      email: data.email,
      name: data.fullName,
      role: data.role,
      token: data.token,
      restaurantId: data.restaurantId,
      createdDate: data.createdDate,
    };

    localStorage.setItem("auth_user", JSON.stringify(loggedInUser));
    localStorage.setItem("auth_token", data.token);

    return { success: true, loggedInUser };
  } catch (err: any) {
    return { success: false, error: err.message || "Something went wrong" };
  }
};
export const loginUser = async (dto: LoginDTO) => {
  try {
    const resp = await fetch(apiRoutes.auth.login, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });

    const result = await resp.json();

    if (!resp.ok || !result.succeeded) {
      const errorMessage = result.error || "Registration failed";
      return { success: false, error: errorMessage };
    }

    const data = result.data;

    const loggedInUser = {
      id: data.id,
      email: data.email,
      name: data.fullName,
      role: data.role,
      token: data.token,
      restaurantId: data.restaurantId,
      createdDate: data.createdDate,
      savedAddresses: data?.savedAddresses,
    };

    localStorage.setItem("auth_user", JSON.stringify(loggedInUser));
    localStorage.setItem("auth_token", data.token);

    return { success: true, loggedInUser };
  } catch (err: any) {
    return { success: false, error: err.message || "Something went wrong" };
  }
};
export const googleLogin = async (dto: GoogleLoginDTO) => {
  try {
    const resp = await fetch(apiRoutes.auth.googleLogin, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });

    const result = await resp.json();

    // Assuming your backend returns standard OperationResult<AuthResponseDto>
    if (!resp.ok || !result.succeeded) {
      const errorMessage = result.errors?.[0] || "Google login failed";
      return { success: false, error: errorMessage };
    }

    const data = result.data;

    const loggedInUser = {
      id: data.id,
      email: data.email,
      name: data.fullName,
      role: data.role,
      token: data.token,
      restaurantId: data.restaurantId,
      createdDate: data.createdDate,
      savedAddresses: data?.savedAddresses,
    };
    localStorage.setItem("auth_user", JSON.stringify(loggedInUser));
    localStorage.setItem("auth_token", data.token);

    return { success: true, loggedInUser };
  } catch (err: any) {
    return { success: false, error: err.message || "Something went wrong" };
  }
};
export const guestLogin = async () => {
  try {
    const resp = await fetch(apiRoutes.auth.guestLogin, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    const result = await resp.json();

    // Assuming your backend returns standard OperationResult<AuthResponseDto>
    if (!resp.ok || !result.succeeded) {
      const errorMessage = result.errors?.[0] || "Guest login failed";
      return { success: false, error: errorMessage };
    }

    const data = result.data;

    const loggedInUser = {
      id: data.id,
      email: data.email,
      name: data.fullName,
      role: data.role,
      token: data.token,
      restaurantId: data.restaurantId,
      createdDate: data.createdDate,
      savedAddresses: data?.savedAddresses,
    };

    localStorage.setItem("auth_user", JSON.stringify(loggedInUser));
    localStorage.setItem("auth_token", data.token);

    return { success: true, loggedInUser };
  } catch (err: any) {
    return { success: false, error: err.message || "Something went wrong" };
  }
};
